module.exports = __webpack_public_path__ + "4986b1.png";